import { Component } from 'react';
import PropTypes from 'prop-types';
import { getAppRoot } from '../identity';
import { setSelectedClassroom } from '../GlobalFunctions';
import { useHistory } from 'react-router-dom';

class ClassroomStudentLink extends Component {
  constructor(props) {
    super(props);

    this.handleOnGotoStudents = this.handleOnGotoStudents.bind(this);
  }

  handleOnGotoStudents(event) {
    event.preventDefault();
    setSelectedClassroom(this.props.classroomIndex);
    this.props.history.push('/students');
  }

  render() {
    const numberOfStudents = this.props.students === undefined ? 0 : this.props.students.length;

    const numberOfStudentsDescription =
      numberOfStudents === 1 ? `${numberOfStudents} Student` : `${numberOfStudents} Students`;

    const link = `/students`;

    if (numberOfStudents === 0) {
      return (
        <a href={link} onClick={this.handleOnGotoStudents}>
          +Add Students
        </a>
      );
    }

    return (
      <div>
        <a href={link} onClick={this.handleOnGotoStudents}>
          {numberOfStudentsDescription}
        </a>
      </div>
    );
  }
}

ClassroomStudentLink.propTypes = {
  students: PropTypes.arrayOf(PropTypes.object),
};

function ClassFunctionWrapper(props) {
  const history = useHistory();
  return <ClassroomStudentLink {...props} history={history} />;
}

export default ClassFunctionWrapper;
